var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.scrollContainerClasses,attrs:{"id":"infinite-scroll-container"}},[_c('div',{attrs:{"id":"infinite-scroll-content"}},[_vm._t("default")],2),(_vm.isLoadingMore)?_c('div',[_vm._t("loading")],2):_vm._e(),_c('div',{ref:"infiniteScrollEnd",class:_vm.scrollEndClass,attrs:{"id":"infinite-scroll-end"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }